import { InferType, object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object({
  providerId: string().required(),
})

export type Request = InferType<typeof Schema>

export type SuccessfulResponse = { jobId: string }

export const url = ({ providerId }) => `/v1/providers/${providerId}/reports/quality_metrics`
